import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 K-VISUAL MASTERPLAN™',
  ideal: 'Alle, die Koreanisch von null an verstehen möchten, ohne jemals eine Sprache gelernt zu haben',
  was: '38€',
  now: '19€',
  features: ['6 komplette Bände (120+ Seiten)', 'Hangeul von null an, visuell erklärt', 'Echte K-Drama- & K-Pop-Ausdrücke', '60-Minuten-Routine mit sichtbarem Fortschritt', '5 kostenlose Boni enthalten', '7-Tage-Zufriedenheitsgarantie', 'Lebenslanger Zugriff & kostenlose Updates'],
  cta: 'K-Visual Masterplan™ holen'
};
const trust = [{
  icon: LockIcon,
  label: '100% Sichere Zahlung'
}, {
  icon: ZapIcon,
  label: 'Sofortiger Zugriff'
}, {
  icon: CreditCardIcon,
  label: 'Kredit- / Debitkarte'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Preise" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-128" data-mp="3vynjyjmxk5d1">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-129" data-mp="4ruhlcgei06x">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.45)]" data-id="element-130" data-mp="9si9s1gd8n2q">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-131" data-mp="3n526r4qeyw5q">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-132" data-mp="3rz6bdhc7is3n">
            <span className="font-semibold text-plum/80" data-id="element-133" data-mp="2uizjfn2ue2kn">Ideal für:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-134" data-mp="2zh13aa83e5x6">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-135" data-mp="2zfzqa07in9ct">Regulärer Preis: {plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "64px",
            paddingBottom: "26px",
            fontFamily: "Cinzel, serif",
            paddingTop: "20px"
          }} data-id="element-136" data-mp="2mhrtnq9z1k46">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-137" data-mp="2w7l58ra45z8f">
              Einmalige Zahlung · Lebenslanger Zugriff
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-138" data-mp="28j1wybr2dmgc">
              Die Zahlung wird in deiner lokalen Währung abgewickelt.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-139" data-mp="2ifww8wv5vqvo">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-140" data-mp="2dh3gexsejnsc">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-141" data-mp="2djg7q1k1vai2" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-142" data-mp="3ox1x9nttne44">
            <CTAButton size="md" data-id="element-143" data-mp="adkkpb8zrih">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-144" data-mp="92fmm62gdps">
            ✅ Du sparst 35€ (65% Rabatt)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-145" data-mp="3nfcxkkd18f3q">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="j151qd1h8m7f">
                <Icon className="h-4 w-4 text-grape" data-id="element-147" data-mp="j37peqf5q38z" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-148" data-mp="a934soqm9o1w" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-149" data-mp="a7s1eq132ibb">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-150" data-mp="e7shef3tz1kh" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-151" data-mp="11yg0zxn3zfmv">
            <span className="font-display font-bold text-plum" data-id="element-152" data-mp="16rhgo7v53j7i">
              🛡️ 7-Tage-Zufriedenheitsgarantie.
            </span>{' '}
            Wenn du in den ersten 7 Tagen denkst, dass das eBook nicht zu dem passt, was du
            brauchst, oder dir nicht den Impuls gibt, den du suchst, fordere deine Rückerstattung an
            und wir geben dir 100% deines Geldes zurück. Wir möchten, dass du ohne Risiko lernst.
          </p>
        </div>
      </div>
    </section>;
}